/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	///////////////////////////////
	// Activate Page DropdownMenus
	///////////////////////////////
	
	/// ACTIVATE ALL DROPDOWNS ///
	$(function() {
	  $("div[class*=dropmenuWrapper]").click(function(e){
	      // Avoid to call below subsequent callback to close all dropdowns
	      e.stopPropagation();
	      var isOpen = false;
	      // Mark if currently clicked dropdown is open
	      if ($(this).hasClass('clicked')) { var isOpen = true; }
	      // Close all open dropdowns right away and...
	      $("div[class*=dropmenuWrapper]").removeClass('clicked');
	      // ..only then Toggle Open or Close of current dropdown if it has not already been closed
	      if (!isOpen) {
	        $(this).toggleClass('clicked'); 
	      }
	   });
	});
	
	$(function() {
	  $("[class*=stopprop]").click(function(e){
	      // Avoid to call below subsequent callback to close all dropdowns
	      e.stopPropagation();
	   });
	});
	
	/// CLOSE ALL OPEN DROPDOWNS WHEN DOCUMENT IS CLICKED ///
	$(document).click(function(){
	  $("div[class*=dropmenuWrapper]").removeClass('clicked');
	});
	
	/// ACTIVATE ALL TOGGLELANGUAGE DROPDOWN ITEMS ///
	$(function() {
	  $("a[class*=dropdown-item][id*=toggleLanguage]").click(function(){
	        // Append Label to Langauge Selector
	        var cl = $(this).attr("rel");
	        var alt = $(this).attr("alt");
	        window.setCookie("language", cl + "/" + alt, 365);
	        window.setLanguage(cl, alt);
	   });
	});
	
	/// place alternative dynamic dropdowns functions here ///
	
	


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// activate_dropdowns.js